var _style, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function Svg3Dots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 600 1200",
    style: {
      enableBackground: "new 0 0 600 1200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M439.5,139.5C439.5,216.6,377,279,300,279s-139.5-62.5-139.5-139.5S222.9,0,300,0S439.5,62.5,439.5,139.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M439.5,586c0,77.1-62.5,139.5-139.5,139.5S160.5,663.1,160.5,586S222.9,446.5,300,446.5S439.5,509,439.5,586"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M439.5,1060.5c0,77.1-62.5,139.5-139.5,139.5s-139.5-62.5-139.5-139.5C160.5,983.4,223,921,300,921 S439.5,983.4,439.5,1060.5"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3Dots);
export default __webpack_public_path__ + "static/media/3dots.3e9b3044fc2c51c9b9cd55f2bd6fae61.svg";
export { ForwardRef as ReactComponent };